//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'QuestionsSection',
  data() {
    return {
      questions: [],
    }
  },
  mounted() {
    this.questions = [...(this.$getBullets('faqScreenFaqs') || [])]
    this.questions.map((item) => {
      item.show = false
    })
  },
  methods: {
    toggle(index) {
      this.$set(this.questions, index, {
        ...this.questions[index],
        show: !this.questions[index].show,
      })
    },
  },
}
